import { useNavigate } from "react-router-dom";
import { useFlowHubAuth } from "../../../../../hooks/useFlowHubAuth";

export const useFlowHubNavbar = () => {
    const navigate = useNavigate();
    const { isLoggedIn, dashboardPath } = useFlowHubAuth();

    const handleLoginClick = () => {
        if (isLoggedIn) {
            navigate(dashboardPath);
        } else {
            navigate("/signin");
        }
    };

    const handleCreateAccountClick = () => {
        navigate("/signup");
    };

    return {
        handleLoginClick,
        handleCreateAccountClick,
    };
};
